export const DRAW_STAGES = Object.freeze({
    UNKNOWN: 'Unknown',
    FIRST_POINT: 'FirstPoint',
    EDGE_SKETCH: 'EdgeSketch',
    SHAPE_SKETCH_INCOMPLETE: 'ShapeSketchIncomplete',
    SHAPE_SKETCH_COMPLETE: 'ShapeSketchComplete',
    LINEAR_SEARCH_ACTIVE: 'LinearSearchActive'
});
